export default "__VITE_ASSET__D5cuc34E__"